<template lang="pug">
  form(v-if="formData" @submit="submit($event, 'fichaTecnica')")
    md-field(:class="getValidationClass('formData.ubicacion')", md-clearable)
      label Ubicación
      md-input(v-model.trim='formData.ubicacion', :disabled='sending')
      span.md-error(v-if='!$v.formData.ubicacion.required') Requerido
    md-field(:class="getValidationClass('formData.superficie')", md-clearable)
      label Longitud-Superficie
      md-input(v-model.trim='formData.superficie', :disabled='sending')
      span.md-error(v-if='!$v.formData.superficie.required') Requerido
    md-field.mgtop(:class="getValidationClass('formData.fuenteFinanciacion')", md-clearable)
      label Fuente Financiación
      md-input(v-model.trim='formData.fuenteFinanciacion', :disabled='sending')
      span.md-error(v-if='!$v.formData.fuenteFinanciacion.required') Requerido
    md-field(:class="getValidationClass('formData.costo')", md-clearable)
      label Costo (En números)
      md-input(v-model.trim='formData.costo', :disabled='sending' @keyup.native="inputValueThousandSeparatorFormat($event, val => { formData.costo = val })")
      span.md-helper-text Moneda por defecto US$. Este valor se usará para sumarse con los costos de los demás proyectos en el panel de resumen
      span.md-error(v-if='!$v.formData.costo.required') Requerido
    md-field(:class="getValidationClass('formData.costoEstimativo')", md-clearable)
      label Descripción del costo (Opcional)
      md-input(v-model.trim='formData.costoEstimativo', :disabled='sending')
      span.md-helper-text En este campo podrá especificar una descripción resumida del proposito del costo así como la referencia a otra moneda del mismo
    md-divider
    br
    .block.ente-ejecutor-container(:class="getValidationClass('formData.enteEjecutor')")
      .block
        label Ente ejecutor
      .md-layout.md-gutter
        .md-layout-item.md-size-33.md-xsmall-size-100.md-medium-size-50(:key='item.text', v-for='item in executors')
          md-checkbox(v-model='modelExecutors', :value='item.text', @change='changeExecutors($event)') {{item.text}}
      span.md-error(v-if='!$v.formData.enteEjecutor.required') Requerido
    md-divider
    br
    .md-layout.md-gutter(v-if="formData.status")
      .md-layout-item.md-size-100
        | Estados por año
      .md-layout-item.md-small-size-100
        md-field(:class="getValidationClass('formData.status.planification')", md-clearable)
          label Planificación
          md-input(type='number', v-model='formData.status.planification', :disabled='sending')
          span.md-error(v-if='!$v.formData.status.planification.required') Requerido
          span.md-error(v-if='!$v.formData.status.planification.minLength') El año debe poseer 4 números
      .md-layout-item.md-small-size-100
        md-field(:class="getValidationClass('formData.status.execution')", md-clearable)
          label En ejecución
          md-input(type='number', v-model='formData.status.execution', :disabled='sending')
          span.md-error(v-if='!$v.formData.status.execution.required') Requerido
          span.md-error(v-if='!$v.formData.status.execution.minLength') El año debe poseer 4 números
      .md-layout-item.md-small-size-100
        md-field(:class="getValidationClass('formData.status.finished')", md-clearable)
          label Finalización
          md-input(type='number', v-model='formData.status.finished', :disabled='sending')
          span.md-error(v-if='!$v.formData.status.finished.required') Requerido
          span.md-error(v-if='!$v.formData.status.finished.minLength') El año debe poseer 4 números
    md-divider
    br
    .block(:class="getValidationClass('formData.types')")
      .block
        label Tipos de proyecto
      .md-layout.md-gutter
        .md-layout-item.md-size-33.md-xsmall-size-100.md-medium-size-50(:key='item.text', v-for='item in types')
          md-checkbox(v-model='modelTypes', :value='item.text', @change='changeTypes($event)') {{item.text}}
      span.md-error(v-if='!$v.formData.types.required') Requerido
    md-divider
    md-field(:class="getValidationClass('formData.families')", md-clearable)
      label Cantidad de familias residentes en el área
      md-input(v-model.trim='formData.families', :disabled='sending' @keyup.native="inputValueThousandSeparatorFormat($event, val => { formData.families = val })")

    md-button.md-raised.md-primary(v-show="!isCreateView" type="submit" ref="saveButton") Guardar

</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { clone } from '@/utils/form.js'
import { projectFilterObject } from '@/constants'
import projectFormMixin from '@/mixins/project-form.js'
import thousandSeparatorMixin from '@/mixins/thousand-separator.js'

export default {
  mixins: [ projectFormMixin, thousandSeparatorMixin ],
  props: {
    isCreateView: {
      type: Boolean,
      default: false
    },
    customValidations: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    modelExecutors: [],
    modelTypes: [],
    executors: projectFilterObject.executors,
    status: projectFilterObject.status,
    types: projectFilterObject.types
  }),
  validations () {
    return {
      formData: {
        families: { },
        enteEjecutor: {
          required
        },
        fuenteFinanciacion: {
          required
        },
        superficie: {
          required
        },
        ubicacion: {
          required
        },
        costo: {
          required
        },
        costoEstimativo: { },
        status: {
          planification: {
            required,
            minLength: 4
          },
          execution: {
            required,
            minLength: 4
          },
          finished: {
            required,
            minLength: 4
          }
        },
        types: {
          required
        },
        ...this.customValidations
      }
    }
  },
  methods: {
    changeExecutors (event) {
      this.value.enteEjecutor = event
      this.formData.enteEjecutor = event
    },
    changeTypes (event) {
      this.value.types = event
      this.formData.types = event
    },
    initDataWhenValuePropIsAssignedFirstTime (value) {
      this.modelExecutors = clone(value.enteEjecutor)
      this.modelTypes = clone(value.types)
    }
  }
}
</script>

<style scoped lang="stylus">
@import '~@/styles/edit-project-form-style'
</style>
